import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITerminationCategory } from "src/models/HumanResources/TerminationCategories.models";

interface TerminationCategoryState {
  terminationCategories: ITerminationCategory[];
  terminationCategoryToEdit: ITerminationCategory | null;
}

const initialState: TerminationCategoryState = {
  terminationCategories: [],
  terminationCategoryToEdit: null,
};

const TerminationCategorySlice = createSlice({
  name: "TerminationCategory",
  initialState,
  reducers: {
    setTerminationCategoryList: (
      state,
      action: PayloadAction<ITerminationCategory[]>
    ) => {
      state.terminationCategories = action.payload;
    },
    concatListTerminationCategory: (
      state: TerminationCategoryState,
      action: PayloadAction<ITerminationCategory[]>
    ) => {
      state.terminationCategories = [
        ...state.terminationCategories.concat(action.payload),
      ];
    },
    setTerminationCategoryToEdit: (
      state,
      action: PayloadAction<ITerminationCategory | null>
    ) => {
      state.terminationCategoryToEdit = action.payload;
    },
    addTerminationCategory: (
      state,
      action: PayloadAction<ITerminationCategory>
    ) => {
      state.terminationCategories.push(action.payload);
    },
    updateTerminationCategory: (
      state,
      action: PayloadAction<ITerminationCategory>
    ) => {
      let itemIndex = state.terminationCategories.findIndex(
        item =>
          item.terminationCategoryId === action.payload.terminationCategoryId
      );
      if (itemIndex !== -1)
        state.terminationCategories[itemIndex] = action.payload;
    },
    deleteTerminationCategory: (state, action: PayloadAction<number>) => {
      const newArray = state.terminationCategories.filter(
        item => item.terminationCategoryId !== action.payload
      );
      state.terminationCategories = newArray;
    },
  },
});

export const {
  setTerminationCategoryList,
  concatListTerminationCategory,
  setTerminationCategoryToEdit,
  addTerminationCategory,
  updateTerminationCategory,
  deleteTerminationCategory,
} = TerminationCategorySlice.actions;

export default TerminationCategorySlice.reducer;
